// The old free-text phone fields let people save bare national numbers
// ("8888 7777"). New saves always carry a country code; this decides who
// still needs to confirm theirs, keeps the nudge off pages where they are
// already editing details, and remembers "not now" for a week.
const SNOOZE_KEY = "mst_phone_confirm_snooze_until";
export const PHONE_CONFIRM_SNOOZE_DAYS = 7;

// True for a saved number we cannot place in a country on our own.
export const needsCountryCode = (stored: string | null | undefined): boolean => {
  const trimmed = (stored ?? "").trim();
  if (!/\d/.test(trimmed)) return false; // nothing saved, completeness prompts handle that
  if (trimmed.startsWith("+")) return false; // canonical
  if (/^00\d/.test(trimmed.replace(/[\s()-]/g, ""))) return false; // international prefix, unambiguous
  return true;
};

// Mid-flow or already-editing pages: the nudge would only get in the way.
export const PHONE_CONFIRM_SKIP_PREFIXES = [
  "/login",
  "/welcome",
  "/onboarding",
  "/owner-onboarding",
  "/list-property",
  "/profile",
  "/edit-property",
  "/claim",
  "/admin",
];

export const shouldSkipPhoneConfirm = (pathname: string): boolean =>
  PHONE_CONFIRM_SKIP_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));

export const isPhoneConfirmSnoozed = (now: number = Date.now()): boolean => {
  try {
    const until = Number(localStorage.getItem(SNOOZE_KEY));
    return Number.isFinite(until) && until > now;
  } catch {
    return false;
  }
};

export const snoozePhoneConfirm = (now: number = Date.now(), days: number = PHONE_CONFIRM_SNOOZE_DAYS): void => {
  try {
    localStorage.setItem(SNOOZE_KEY, String(now + days * 86_400_000));
  } catch {
    /* storage unavailable, the nudge simply returns next visit */
  }
};

export const clearPhoneConfirmSnooze = (): void => {
  try {
    localStorage.removeItem(SNOOZE_KEY);
  } catch {
    /* ignore */
  }
};
